// components/ForceReloadButton.jsx
import React from 'react';

const ForceReloadButton = () => {
  const forceReload = () => {
    // Esto simula Ctrl + F5 forzando la recarga con caché ignorada
    window.location.reload(true); // true ya no se usa mucho, pero sigue funcionando en navegadores
  };

  return (
    <button
      onClick={forceReload}
    //   style={{
    //     position: 'fixed',
    //     top: 10,
    //     right: 10,
    //     padding: '8px 12px',
    //     background: '#007bff',
    //     color: '#fff',
    //     border: 'none',
    //     borderRadius: '4px',
    //     zIndex: 9999,
    //     cursor: 'pointer'
    //   }}
    className='bg-orange-500 p-2 text-sm rounded-md text-white font-semibold'
    >
      Actualizar
    </button>
  );
};

export default ForceReloadButton;
